import { unidades } from "@/constants/unidades";

function getUnidade(id) {
  const data = unidades.options.find(element => element.id === id);
  return data?.label || "Não identificado"
}

export default getUnidade;
